import { render, staticRenderFns } from "./customerservice.vue?vue&type=template&id=c88a3eec&"
import script from "./customerservice.vue?vue&type=script&lang=js&"
export * from "./customerservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/components/kirbyimage.vue').default})
